import * as yup from 'yup'

yup.setLocale({
	string: {
		email: 'mktEmailFormatError'
	}
})

export default yup
